import { CreateParkingSessionWithPrepaidInput } from 'types/states';
import { create } from 'zustand';

type PrepaidTicketState = {
  confirmPrepaidTicketData: CreateParkingSessionWithPrepaidInput | undefined;
};

type PrepaidTicketActions = {
  setConfirmPrepaidTicketData: (
    data: CreateParkingSessionWithPrepaidInput | undefined
  ) => void;
};

export const usePrepaidTicketStore = create<
  PrepaidTicketState & PrepaidTicketActions
>()((set) => ({
  confirmPrepaidTicketData: undefined,
  setConfirmPrepaidTicketData: (data) =>
    set({ confirmPrepaidTicketData: data }),
}));
